module.exports = __webpack_public_path__ + "img/page-1_img004.8825ff6a.png";